/**
 * storefront.vegabooking.io has no home page of its own — the marketing site lives on
 * app.vegabooking.io. Anyone landing here followed a truncated link.
 */
export function LandingRedirect() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background px-margin-mobile text-center">
      <h1 className="font-display text-headline-md text-on-surface">Vega Booking</h1>
      <p className="max-w-md text-body-md text-on-surface-variant">
        This address opens a specific salon&rsquo;s booking page. Use the link your salon gave you,
        which looks like <span className="font-medium text-on-surface">storefront.vegabooking.io/your-salon</span>.
      </p>
      <a
        href="https://app.vegabooking.io"
        className="text-body-md text-primary underline underline-offset-4"
      >
        Go to vegabooking.io
      </a>
    </div>
  )
}
